import { createSlice } from '@reduxjs/toolkit';
import { createSubActivity, ISubActivity } from '../../../models/subActivities';

interface ISubActivityState {
    subActivities: ISubActivity[],
    subActivity: ISubActivity,
    isLoading: boolean,
};

const initialState: ISubActivityState = {
    subActivities: [],
    subActivity: createSubActivity({}),
    isLoading: false,
};

export const subActivitiesSlice = createSlice({
    name: 'subActivities',
    initialState,
    reducers: {
        setSubActivities: (state, action) => {
            state.isLoading = false;
            state.subActivities = action.payload.subActivities;
        },
        setSubActivity: (state, action) => {
            state.isLoading = false;
            state.subActivity = action.payload.subActivity;
        },
        startLoadingSubActivities: (state) => {
            state.isLoading = true;
        },
        updateSubActivities: (state, action) => {
            state.isLoading = false;

            const updated: ISubActivity[] = state.subActivities.map((item: ISubActivity) => {
                if (item.id === action.payload.subActivity.id)
                    return action.payload.subActivity;
                return item;
            });
            state.subActivities = updated;
        },
    }
});

// Action creators are generated for each case reducer function
export const {
    setSubActivities,
    setSubActivity,
    startLoadingSubActivities,
    updateSubActivities
} = subActivitiesSlice.actions;